// base component
import { CustomSelectComponent } from './custom-select.component';

export const CustomSelectModule = angular.module('topbroker.custom-select', [])
  .component('customSelect', CustomSelectComponent)
  .name;
